<template>
  <div :class="['file-row', { ['file-row__deleting']: isDeleting }]" role="row">
    <div class="file-row__cell file-row__file-name" role="gridcell">
      {{fileName}}
    </div>

    <div class="file-row__cell file-row__cell-wrapper" role="gridcell">
      <p class="file-row__cell-item file-row__created">
        {{fileCreatedAt}}
      </p>
      <a
          :href="file.url"
          class="file-row__cell-item file-row__download file-row__link"
          :title="`download ${fileName} file`">
        download
      </a>
      <a
          href="#"
          class="file-row__cell-item file-row__link file-row__delete"
          :title="`delete ${fileName} file`"
          @click.prevent="deleteFile">
        delete
      </a>
    </div>
  </div>
</template>

<script>
  import AxiosMixin from '../mixins/AxiosMixin'
  import { mapState } from 'vuex'
  import moment from 'moment'

  export default {
    props: {
      file: {
        required: true,
        type: Object
      },
    },

    name: 'FileRow',

    mixins: [AxiosMixin],

    data() {
      return {
        isDeleting: false,
      }
    },

    computed: {
      fileCreatedAt: function () {
        const brandTimezone = this.brand?.time_zone,
          momentDateTime = moment.utc(this.file.created_at, 'YYYY-MM-DD HH:mm:ss'),
          tzDateTime = brandTimezone ? momentDateTime.tz(brandTimezone) : momentDateTime
        return tzDateTime.format('MM/DD/YYYY, hh:mma')
      },

      fileName: function () {
        return this.file.file_name
      },

      ...mapState(['brand'])
    },

    methods: {
      deleteFile() {
        this.isDeleting = true
        this.$emit('deleteFile', this.file)
      },
    },
  }
</script>

<style lang="sass">
  @import '../../assets/sass/colors'
  .file-row
    display: flex
    justify-content: space-between
    padding: 0.5rem

    &__file-name
      flex-basis: 40%

    &__cell-wrapper
      display: flex
      justify-content: flex-end

    &__cell-item
      margin: 0 0.5rem

    &__created
      font-size: 1rem

    &__link
      color: $primary-color

      &:hover
        color: $title-color

    &__deleting
      opacity: 0.5
      pointer-events: none

</style>